import { useState } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { NotificationPanel } from '@eti/components';
import { mediaQueries } from '@eti/styles';
import { constants } from '@eti/utils';
import { useProperty, useTranslation } from '@eti/providers';

const PriceDropProtectionNotification = ({ className, linkText, text, title }) => {
  const [isVisible, setIsVisible] = useState(!sessionStorage.getItem('showPriceDropProtection'));
  const { t } = useTranslation();
  const { p } = useProperty();

  const handleCloseCallback = () => {
    setIsVisible(false);
    sessionStorage.setItem('showPriceDropProtection', false);
  };

  return (
    isVisible && (
      <Media query={mediaQueries.medium.up}>
        {(matches) => (
          <NotificationPanel
            className={className}
            closeButtonLabel={t('Close')}
            dataTestId="price-drop-protection"
            icons={[{ id: 'price-drop-protection', size: matches ? '6rem' : '3rem' }]}
            onClose={handleCloseCallback}
            title={title}
            type={constants.notificationTypes.NOTIFICATION_PRICE_DROP_PROTECTION}
          >
            {text && <p>{text}</p>}
            <a
              href={p('PriceDropProtection.DisplayBanners.Link')}
              rel="noreferrer noopener"
              target="_blank"
            >
              {linkText}
            </a>
          </NotificationPanel>
        )}
      </Media>
    )
  );
};

PriceDropProtectionNotification.propTypes = {
  className: PropTypes.string,
  linkText: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
};

export default PriceDropProtectionNotification;
